import type { ReactNode } from "react";

type FilledRow = {
  label: string;
  value: string;
};

type Props = {
  audienceFor?: string | null;
  formOfConduct?: string | null;
  coachingStyle?: string | null;
  typicalEngagement?: string | null;
  brandName?: string | null;
  brandLogoUrl?: string | null;
};

export function CoachAtAGlance({
  audienceFor,
  formOfConduct,
  coachingStyle,
  typicalEngagement,
  brandName,
  brandLogoUrl,
}: Props): ReactNode {
  const rows: FilledRow[] = [
    { label: "For", value: audienceFor },
    { label: "Format", value: formOfConduct },
    { label: "Style", value: coachingStyle },
    { label: "Engagement", value: typicalEngagement },
  ].filter(
    (r): r is FilledRow =>
      typeof r.value === "string" && r.value.trim().length > 0,
  );

  const hasBrand = Boolean(brandName && brandLogoUrl);

  if (rows.length === 0 && !hasBrand) return null;

  return (
    <div className="mt-3 rounded-xl border border-gray-200 bg-white p-4">
      {rows.length > 0 && (
        <dl className="grid grid-cols-[max-content_1fr] gap-x-4 gap-y-2">
          {rows.map((row) => (
            <RowItem key={row.label} label={row.label} value={row.value} />
          ))}
        </dl>
      )}
      {hasBrand && brandLogoUrl && brandName && (
        <div className="mt-3 flex items-center gap-2 border-t border-gray-200 pt-3">
          <img
            src={brandLogoUrl}
            alt=""
            className="size-6 rounded object-cover"
          />
          <span className="text-sm font-medium text-gray-900">{brandName}</span>
        </div>
      )}
    </div>
  );
}

function RowItem({ label, value }: { label: string; value: string }) {
  return (
    <>
      <dt className="text-xs font-medium tracking-[0.16em] text-gray-600 uppercase">
        {label}
      </dt>
      <dd className="text-[13px] font-medium text-gray-900">{value}</dd>
    </>
  );
}
